.read-more {
  font-family: 'Karla_400Regular';
  padding: 2;
  margin: 2;
  color: '#353B4A';
}
